<template>
  <fb-list-body
      :pager="pager"
      :showBtnGroup="true"
      :showSearchForm="false"
      @handlePagerSizeChange="handlePagerSizeChange"
      @handlePagerIndexChange="handlePagerIndexChange"
  >
    <template slot="btn-group">
      <el-radio-group v-model="tabCurrent">
        <el-radio-button label="1">{{$t('lang.未提交')}}</el-radio-button>
        <el-radio-button label="2">{{$t('lang.待审核')}}</el-radio-button>
        <el-radio-button label="3">{{$t('lang.已创建')}}</el-radio-button>
        <el-radio-button label="4">{{$t('lang.已退回')}}</el-radio-button>
      </el-radio-group>
    </template>

    <template slot="other">
      <div style="margin-bottom: 14px" >
        <el-button icon="el-icon-plus" @click="$router.push('/apk-add')" v-show="tabCurrent == 1" style="margin-right: 14px">{{$t('lang.新增')}}</el-button>
        <el-button icon="el-icon-delete" @click.native="handleBatchDelete" v-show="tabCurrent == 4 || tabCurrent == 1" style="margin-left: 0;">{{$t('lang.删除')}}</el-button>
      </div>

    </template>

    <template slot="table">
      <component :is="currentView[tabCurrent]" :tableData="tableData"
                 @approval="handlerApproval"
                 @delete="handleDelete"
                 @changeTest="handleChangeTest"
                 @changeRelease="handleChangeRelease"
                 @recall="handleRecall"
                 @selection-change="handleSelectionChange"></component>

    </template>

  </fb-list-body>
</template>

<script>
import AuditTable from "../../components/audit-table/AuditTable";
import BeenCreatedTable from "../../components/been-created-table/BeenCreatedTable";
import BeenReturnedTable from "../../components/been-returned-table/BeenReturnedTable";
import NotSubmitTable from "../../components/not-submit-table/NotSubmitTable";

export default {
  name: "childApkList",
  components: {
    AuditTable,
    BeenCreatedTable,
    BeenReturnedTable,
    NotSubmitTable
  },
  props: {
    timestamp: {
      type: Number,
      default: function () {
        return new Date().getTime();
      },
    },
  },
  data() {
    return {
      api: {
        list: this.$api.subApk.list,
        delete: this.$api.subApk.delete,
        batchDelete: this.$api.subApk.batchDelete,
        commitApproval: this.$api.subApk.commitApproval,
        recall: this.$api.subApk.recall,
        updateTestStatus: this.$api.subApk.updateTestStatus,
        updateReleaseStatus: this.$api.subApk.updateReleaseStatus,
      },
      searchForm: {
        status: 'new',
        brandOwnerCode: this.$store.state.userInfo['brandOwnerCode']
      },
      tableData: [],
      selection: [],
      pager: {
        pageSize: 10,
        pageIndex: 1,
        itemCount: 1,
      },
      tabCurrent: 1,
      currentView: {
        '1': 'NotSubmitTable',
        '2': 'AuditTable',
        '3': 'BeenCreatedTable',
        '4': 'BeenReturnedTable',
      },
      tableDataCount: {},
      statusList: ['new', 'pending', 'approved', 'rejected'],
    };
  },
  computed: {
    searchParams() {
      return Object.assign({}, this.$route.query, this.searchForm, this.pager);
    },
  },
  watch: {
    tabCurrent: {
      handler(current) {
        this.searchForm['status'] = this.statusList[current - 1];
        this.tableData = [];
        this.handleSearch();
      },
      deep: true,
    },
    timestamp() {
      this.handleSearch();
    },
    "pager.pageIndex": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams,
        });
        this.handleSearch();
      },
      deep: true,
      immediate: true,
    },
    "pager.pageSize": {
      handler() {
        this.$router.updateQuery({
          path: this.$route.path,
          query: this.searchParams,
        });
        this.handleSearch();
      },
      deep: true,
    },
  },
  methods: {
    handleScreen() {
      this.pager.pageIndex = 1;
      this.pager.pageSize = 10;
      this.pager.itemCount = 0;
      this.handleSearch();
    },

    handleChangeTest(row) {
      const vm = this;
      let text = row.testStatus != 'running' ? '发布测试' : '取消测试'
      vm.$confirm(`您现在正在进行${text}操作, 是否继续?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          code: row.code,
          testStatus: row.testStatus != 'running' ? 'running' : 'not_start',
        }
        vm.$http.post(vm.api.updateTestStatus, vm.$qs.stringify(data)).then(res => {
          if(res.data.status != 200) {
            vm.$message.error(res.data.desc);
            return;
          }
          vm.handleSearch();
        })
      })


    },

    handleChangeRelease(row) {
      const vm = this;
      let text = row.releaseStatus != 'release' ? '发布上线' : '取消上线';
      vm.$confirm(vm.$t(`lang.您现在正在进行${text}操作, 是否继续?`), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "success",
      }).then(() => {
        let data = {
          code: row.code,
          releaseStatus: row.releaseStatus != 'release' ? 'release' : 'not_release',
        }
        vm.$http.post(vm.api.updateReleaseStatus, vm.$qs.stringify(data)).then(res => {
          if(res.data.status != 200) {
            vm.$message.error(res.data.desc);
            return;
          }
          vm.handleSearch();
        })
      })

    },

    handlerApproval(row) {
      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行提交审核操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "success",
      })
          .then(() => {
            vm.$http
                .post(vm.api.commitApproval, vm.$qs.stringify({code: row.code}))
                .then((resp) => {
                  if (resp.data.status === 200) {
                    vm.$message({type: "success", message: resp.data.desc});
                    vm.handleSearch();
                  } else {
                    vm.$message({type: "error", message: resp.data.desc});
                  }
                });
          })
          .catch(() => {
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
          });
    },
    handleRecall(row) {
      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行撤销操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
          .then(() => {
            vm.$http
                .post(vm.api.recall, vm.$qs.stringify({code: row.code}))
                .then((resp) => {
                  if (resp.data.status === 200) {
                    vm.$message({type: "success", message: resp.data.desc});
                    vm.handleSearch();
                  } else {
                    vm.$message({type: "error", message: resp.data.desc});
                  }
                });
          })
          .catch(() => {
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
          });
    },

    handleEdit(e) {
      if (e && e.code) {
        this.$router.push({path: "edit", query: {code: e.code}});
        return;
      }

      if (!this.selection.length) {
        this.$message({type: "warning", message: this.$t('lang.未选择记录')});
        return;
      }

      if (this.selection.length > 1) {
        this.$message({type: "warning", message: this.$t('lang.一次只能编辑一条数据')});
        return;
      }

      this.$router.push({
        path: "edit",
        query: {code: this.selection[0].code},
      });
    },

    handleDelete(row) {
      let vm = this;

      vm.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
          .then(() => {
            vm.$http
                .post(vm.api.delete, vm.$qs.stringify({code: row.code}))
                .then((resp) => {
                  if (resp.data.status === 200) {
                    vm.$message({type: "success", message: resp.data.desc});
                    vm.handleSearch();
                  } else {
                    vm.$message({type: "error", message: resp.data.desc});
                  }
                });
          })
          .catch(() => {
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
          });
    },
    handleBatchDelete() {
      let vm = this;

      if (!this.selection.length) {
        this.$message({type: "warning", message: vm.$t('lang.未选择记录')});
        return;
      }

      let codes = [];

      this.selection.forEach((e) => {
        codes.push(e.code);
      });

      this.$confirm(vm.$t('lang.您现在正在进行删除操作'), vm.$t('lang.提示'), {
        confirmButtonText: vm.$t('lang.确定'),
        cancelButtonText: vm.$t('lang.取消'),
        type: "warning",
      })
          .then(() => {
            vm.$http.post(this.api.batchDelete, codes).then((resp) => {
              if (resp.data.status === 200) {
                vm.$message({type: "success", message: resp.data.desc});
                vm.handleSearch();
              } else {
                vm.$message({type: "error", message: resp.data.desc});
              }
            });
          })
          .catch(() => {
            // this.$message({
            //     type: 'info',
            //     message: '已取消删除'
            // });
          });
    },
    handleSelectionChange(selection) {
      console.log(selection);
      this.selection = selection;
    },
    handlePagerSizeChange(e) {
      this.pager.pageSize = e;
    },
    handlePagerIndexChange(e) {
      this.pager.pageIndex = e;
    },
    handleSearch() {
      let vm = this;
      this.$http.post(this.api.list, this.$qs.stringify(this.searchParams)).then((resp) => {
            for (let key in resp.data.data) {
              if (resp.data.data[key] instanceof Array) {
                vm.tableData = resp.data.data[key];
              }
            }

            //处理分页
            vm.pager.pageIndex = resp.data.data.pager.pageIndex;
            vm.pager.pageSize = resp.data.data.pager.pageSize;
            vm.pager.itemCount = resp.data.data.pager.itemCount;
          });
    },
    handleReset() {
      if (Object.keys(this.searchForm).length) {
        this.searchForm = {};
        this.searchForm = {
          brandOwnerCode: this.$store.state.userInfo['brandOwnerCode'],
          status: this.statusList[this.tabCurrent - 1],
        }
        this.pager.pageIndex = 1;
        this.pager.pageSize = 10;
        this.pager.itemCount = 0;
        this.handleSearch();
      }

    }
  },
  created() {
    for (let key in this.searchForm) {
      if (this.$route.query[key]) {
        this.searchForm[key] = this.$route.query[key];
      }
    }
  },
};
</script>

<style scoped>
</style>
